import React, { useState, useEffect } from "react";
import "./pdf.css";
import Disclaimer from "./disclaimer";
import TableofContent from "./tableOfContents";
import TitlePage from "./titlePage";
import ProjectOverview from "./projectOverview";
import ModuleConfig from "./moduleConfig";
import DiagramView from "./diagramView";
import ProductionForecast from "./productionForecast";
import ModuleInformation from "./moduleInformation";
import ConsumptionChart from "./consumptionChart";
import ConsumptionForecast from "./consumptionForecast";
import ConsumptionCoverage from "./consumptionCoverage";
import ReturnOnInvestment from "./returnOnInvestment";
import FinancialAnalysis from "./financialAnalysis";
import InverterConfig from "./inverterConfig";
import EnvironmentalDetails from "./environmentalDetails";
import StructureDatasheet from "./structureDatasheet";
import InverterDatasheet1 from "./inverterDatasheet1";
import InverterDatasheet2 from "./inverterDatasheet2";
import PanelDatasheet1 from "./panelDatasheet1";
import PanelDatasheet2 from "./panelDatasheet2";
import InverterDetail from "./inverterDetail.jsx";

import { useSelector } from "react-redux";
import SimulationResult from "./simulationResult.jsx";
import { alignPanelData, allRoofStructure } from "./pdfFunction.jsx";
// import ElectricalConfiguration from "./electrical.jsx";

const PDFALLRoof = (props) => {
  const reportOptions = useSelector((state) => state.reportFeatures);
  const roofInfo = useSelector((state) => state.roof);
  const quantityInfo = useSelector((state) => state.quantity);
  const roofData = quantityInfo?.roofData || [];
  const roofIndex = quantityInfo.roofNo;
  const check = quantityInfo.allRoof;
  const roofDetail = roofData[roofIndex];
  const [structureData, setStructureData] = useState([]);
  const [panelData, setPanelData] = useState([]);
  const [tableContent, setTableContent] = useState([
    {
      title: "Disclaimer",
      pageNo: "22",
    },
  ]);


  useEffect(() => {
    let pages = [];
    let pageNo = 3;
    for (let i = 0; i < reportOptions.length; i++) {
      const element = reportOptions[i];
      if (element[2]) {
        const value = {
          title: element[0],
          pageNo: pageNo,
        };
        pages.push(value);
        pageNo++;

        if (element[0] === "Detail Structure Layout") {
          pageNo += 1;
        }

        if (element[0] === "Product Data Sheets") {
          const pageTitle = element[0];
          const value = allRoofStructure({
            roofData,
            roofDetail,
            check,
            pageTitle,
          });
          setStructureData(value);
          const panel = alignPanelData({
            roofData,
            roofDetail,
            check,
          });
          setPanelData(panel);
          pageNo += value.length + panel.length * 2 + 1;
        }
      }
      if (i === reportOptions.length - 1) {
        const value = {
          title: "Disclaimer",
          pageNo: pageNo,
        };
        pages.push(value);
        pageNo++;
      }
    }
    setTableContent(pages);
    // eslint-disable-next-line
  }, []);

  return (
    <React.Fragment>
      <div className="pdf-body">
        <TitlePage />
        <TableofContent tableContent={tableContent} />
        {reportOptions[0][2] && (
          <>
            {quantityInfo.electricalConfiguration === "All Roof" ? (
              <ProjectOverview tableContent={tableContent} />
            ) : (
              roofData.map((item, i) => (
                <ProjectOverview
                  key={i}
                  tableContent={tableContent}
                  roofDetail={item}
                  index={i}
                />
              ))
            )}
          </>
        )}
        {roofData.map((item, i) => (
          <>
            {reportOptions[1][2] && (
              <ModuleConfig
                tableContent={tableContent}
                roofDetail={item}
                index={i}
              />
            )}
            {reportOptions[2][2] &&
              item.mountingStructure !== "Customized Structure" &&
              (item.structureType === "Multiple" ? (
                item.multipleStructure.map((structure, index) => (
                  <DiagramView
                    key={index}
                    tableContent={tableContent}
                    index={index}
                    structureName={structure.structureType}
                  ></DiagramView>
                ))
              ) : (
                <DiagramView
                  key={i}
                  tableContent={tableContent}
                  index={i}
                  structureName={item.mountingStructure}
                ></DiagramView>
              ))}
          </>
        ))}
        {reportOptions[3][2] && (
          <ModuleInformation tableContent={tableContent} />
        )}
        {reportOptions[4][2] && (
          <>
            {quantityInfo.electricalConfiguration === "All Roof" ? (
              <ProductionForecast tableContent={tableContent} />
            ) : (
              roofData.map((item, i) => (
                <ProductionForecast
                  tableContent={tableContent}
                  key={i}
                  roofDetail={item}
                  index={i}
                />
              ))
            )}
          </>
        )}
        {reportOptions[5][2] && (
          <ConsumptionChart tableContent={tableContent} />
        )}
        {reportOptions[6][2] && (
          <SimulationResult tableContent={tableContent} />
        )}
        {reportOptions[7][2] && (
          <ConsumptionForecast tableContent={tableContent} />
        )}
        {reportOptions[8][2] && (
          <ConsumptionCoverage tableContent={tableContent} />
        )}
        {reportOptions[9][2] && (
          <FinancialAnalysis tableContent={tableContent} />
        )}
        {reportOptions[10][2] && (
          <ReturnOnInvestment tableContent={tableContent} />
        )}

        {quantityInfo.electricalConfiguration === "All Roof" ? (
          <>
            {reportOptions[11][2] && (
              <InverterConfig
                tableContent={tableContent}
                index={0}
                inverterInfo={roofInfo.value.inverterAnalysis}
              />
            )}
            {reportOptions[12][2] && (
              <InverterDetail
                tableContent={tableContent}
                index={0}
                inverterInfo={roofInfo.value.inverterAnalysis}
                roofDetail={roofDetail}
              />
            )}
          </>
        ) : (
          roofData.length > 0 &&
          roofData.map((item, index) => (
            <React.Fragment key={index}>
              {reportOptions[11][2] && (
                <InverterConfig
                  tableContent={tableContent}
                  inverterInfo={item.inverterAnalysis}
                  index={index}
                />
              )}
              {reportOptions[12][2] && (
                <InverterDetail
                  tableContent={tableContent}
                  inverterInfo={item.inverterAnalysis}
                  index={index}
                  roofDetail={item}
                />
              )}
            </React.Fragment>
          ))
        )}

        {reportOptions[13][2] && (
          <EnvironmentalDetails tableContent={tableContent} />
        )}
        {reportOptions[14][2] && (
          <>
            {reportOptions[14][3][0][1] &&
              structureData.map((item, i) => (
                <StructureDatasheet
                  key={i}
                  tableContent={tableContent}
                  index={i}
                  structureName={item.structure}
                ></StructureDatasheet>
              ))}

            {reportOptions[14][3][1][1] && (
              <>
                <InverterDatasheet1
                  tableContent={tableContent}
                  indexValue={panelData.length}
                />
                <InverterDatasheet2
                  tableContent={tableContent}
                  indexValue={panelData.length}
                />
              </>
            )}
            {reportOptions[14][3][2][1] &&
              panelData.map((item, i) => (
                <React.Fragment key={i}>
                  <PanelDatasheet1
                    tableContent={tableContent}
                    index={i}
                    panelData={panelData}
                  />
                  <PanelDatasheet2
                    tableContent={tableContent}
                    index={i}
                    panelData={panelData}
                  />
                </React.Fragment>
              ))}
          </>
        )}
        <Disclaimer tableContent={tableContent} />
      </div>
    </React.Fragment>
  );
};

export default PDFALLRoof;
